import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromGbmReducer from '../messages.reducer';
import * as fromGbmSelector from '../selectors/gbmConversations.selectors';
import * as fromGbmActions from '../actions/gbmConversations.actions';

@Injectable()
export class GbmConversationsStore {
  constructor(public store: Store<fromGbmReducer.MessagesState>) {}

  get gbmConversationsState$() {
    return this.store.select(fromGbmSelector.gbmConversationsState);
  }
  get conversationsState$() {
    return this.store.select(fromGbmSelector.conversationsState);
  }
  get conversationsData$() {
    return this.store.select(fromGbmSelector.conversationsData);
  }
  get conversationsLoading$() {
    return this.store.select(fromGbmSelector.conversationsIsLoading);
  }
  get conversationsSuccess$() {
    return this.store.select(fromGbmSelector.conversationsSuccess);
  }
  get conversationsError$() {
    return this.store.select(fromGbmSelector.conversationsError);
  }
  get conversationsHasBeenFetched$() {
    return this.store.select(fromGbmSelector.conversationsHasBeenFetched);
  }
  get seletedConversationId$() {
    return this.store.select(fromGbmSelector.seletedConversationId);
  }

  //Conversation's messages
  get messagesState$() {
    return this.store.select(fromGbmSelector.messagesState);
  }
  get messagesData$() {
    return this.store.select(fromGbmSelector.messagesData);
  }
  get messagesLoading$() {
    return this.store.select(fromGbmSelector.messagesLoading);
  }
  get messagesError$() {
    return this.store.select(fromGbmSelector.messagesError);
  }
  get messagesSuccess$() {
    return this.store.select(fromGbmSelector.messagesSuccess);
  }

  getGbmConversations() {
    this.store.dispatch(fromGbmActions.getGbmConversationsBeginAction({}));
  }

  getGbmConversationById(id: any) {
    this.store.dispatch(fromGbmActions.getGbmConversationsBeginAction({}));
  }

  getGbmConversationMessages(conversationId: string | number) {
    this.store.dispatch(
      fromGbmActions.getGbmConversationMessagesBeginAction({
        payload: conversationId,
      })
    );
  }

  replyGbmConversationMessage(
    conversationId: string | number,
    message: string
  ) {
    this.store.dispatch(
      fromGbmActions.replyGbmConversationMessageBeginAction({
        conversationId,
        message,
      })
    );
  }
}
